import { useMutation, useQueryClient } from '@tanstack/react-query';
import { updateTrunkType } from 'API/TrunkTypes/updateTrunkType';

const useUpdateTrunkType = (onSuccess, onError) => {
    const queryClient = useQueryClient();

    const update = async (trunkTypeData) => {
        const response = await updateTrunkType(trunkTypeData);
        return response.data;
    };

    return useMutation({
        mutationFn: update,
        onSuccess: (data, variables) => {
            queryClient.invalidateQueries({ queryKey: ['TrunkTypes'] });
            queryClient.invalidateQueries({
                queryKey: ['TrunkType', variables.id],
            });
            if (onSuccess) {
                onSuccess(data);
            }
        },
        onError: (error) => {
            if (onError) {
                onError(error);
            }
        },
    });
};

export default useUpdateTrunkType;
